<template>
    <div class="main-symptom-list-wrapper">
        <div v-if="symptoms.length > 0">

            <v-radio-group style="padding: 4px 0 0" v-model="crtSelectedMainSymptomCode" hide-details>

                <v-list class="symptom-list component-bg-color-important">
                    <v-list-tile
                        v-for="symptom in symptoms"
                        :key="symptom.code"
                        @click="selectMainSymptom(symptom)"
                        :id="'S_' + symptomListSourceType + '_' + symptom.code"
                        class="symptoms-search-pf"
                    >
                        <v-list-tile-content>
                            <v-radio :value="symptom.code"></v-radio>
                        </v-list-tile-content>
                        <v-list-tile-action>
                            <v-list-tile-title>
                                <span v-if="typeof symptom.name.text !== 'undefined' && typeof symptom.name.match !== 'undefined'"
                                      class="symptom-name"
                                      v-html="markMatchedStringInSymptomName(symptom.name.text, symptom.name.match)">
                                </span>
                                <span v-else
                                      class="symptom-name"
                                      v-html="symptom.name">
                                </span>
                            </v-list-tile-title>
                            <v-list-tile-sub-title v-if="symptom.synonyms && symptom.synonyms.length > 0">
                                <span class="symptom-synonyms">
                                    <span class="symptom-synonym-item"
                                          v-for="synonym in symptom.synonyms"
                                          v-html="markMatchedStringInSymptomName(synonym.text, synonym.match) + '' + '<b>&#124;</b>'">
                                    </span>
                                </span>
                            </v-list-tile-sub-title>
                        </v-list-tile-action>

                    </v-list-tile>
                </v-list>
            </v-radio-group>
        </div>

    </div>
</template>

<!-- ################################################################## -->

<script>

import {mapGetters} from 'vuex';
import MoreContent from "../../../../../common/components/svg/shared/MoreContentIcon";

import Vue from "vue";
import axios from 'axios/dist/axios';

export default {
    name: 'MainSymptomList',
    components:{
        MoreContent,
    },
    props: {
        symptoms: {
            type: Array,
            default: () => {
                return [];
            }
        },
        selectedMainSymptomCode: {
            type: String,
            default: ""
        },
        selectedMainSymptom: {
            type: Object,
            default: null
        },
        symptomListSourceType: { // Can be: "SEARCH" or "CHAPTER_TREE"
            type: String,
            default: ''
        }
    },
    data() {
        return {
            radioButtonPlugin: Vue.RadioButton.RadioButtonSvg,
        }
    },

    computed: {
        ...mapGetters({
            getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
            getMustShowChooseMainSymptomPopup: 'ChatBotStore/getMustShowChooseMainSymptomPopup',
        }),
        crtSelectedMainSymptomCode: {
            get() {
                return this.selectedMainSymptomCode;
            },
            set(newSelectedSymptom) {
                this.$emit('onMainSymptomSelected', newSelectedSymptom);
            }
        },
    },

    mounted() {
        this.setUnselectedRadioButton();

        this.$nextTick(() => {
            this.setSelectedRadioButtonColor();
        });

        setTimeout(() => {
            // Scroll to already selected symptom (edit mode).
            let providedAnswerElem_mainSymptom = document.querySelector('.choose-main-symptom-popup .input-group--active');

            if (providedAnswerElem_mainSymptom) {
                providedAnswerElem_mainSymptom.scrollIntoView();
            }
        }, 150);

    },

    watch: {

        crtSelectedMainSymptomCode() {

            setTimeout(() => {
                this.setSelectedRadioButtonColor();
                this.setUnselectedRadioButton();
            }, 100);

        },

        symptoms() {
            this.$nextTick(() => {
                this.setUnselectedRadioButton();
                this.setSelectedRadioButtonColor();
            })
        }
    },

    methods: {

        scrollToBottom() {
            let div = this.$el.closest('.input-group');

            div.scrollTop = div.scrollHeight - div.clientHeight; // this.UtilitiesPlugin.smoothScrollTo(maxScrollTop);
        },

        setUnselectedRadioButton() {
            const symptomList = document.querySelector('div.main-symptom-list-wrapper ul.symptom-list');

            const radioButtons = symptomList.getElementsByClassName('icon icon--selection-control');
            for (let i = 0; i < radioButtons.length; i++) {
                if (radioButtons.item(i).innerHTML === 'radio_button_unchecked' || radioButtons.item(i).innerHTML === 'radio_button_checked' ) {
                    radioButtons.item(i).innerHTML = '';
                }
            }
        },
        markMatchedStringInSymptomName(symptomName, matchedString) {
            let result;
            if (!symptomName) {
                result = "";
            }
            else if (matchedString === null) {
                result = symptomName;
            }
            else {
                result = symptomName.replace(matchedString, '<span class="match"><b>'+matchedString+'</b></span>');
            }

            return result;
        },

        selectMainSymptom(selectedSymptom) {
            this.crtSelectedMainSymptomCode = selectedSymptom;

            axios.post(process.env.API_BASE_URL_PATHFINDER + '/assessment/clickMainSymptom', {
                symptomCode: selectedSymptom.code
            });
        },


        setSelectedRadioButtonColor() {
            let elemIconSelectedRadioIcon = document.querySelector('.choose-main-symptom-popup .main-symptom-list-wrapper .input-group--active .icon--radio');
            if (elemIconSelectedRadioIcon) {
                elemIconSelectedRadioIcon.innerHTML = this.radioButtonPlugin();
            }

        }
    }
}

</script>

<!-- ################################################################## -->

<style lang="scss">



</style>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/answer-list/main-symptom-popup/MainSymptomList.vue